import * as React from 'react';

const SvgExternalOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M19.11 6.224 12.332 13 11 11.667l6.78-6.781H13V3L21 3l-.02 8.023-1.886-.005.015-4.794Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16 19v-7h2v9H3V6h9v2H5v11h11Z", fill: "currentColor" })));

export { SvgExternalOutline as default };
